
export enum DialogType {
  INFO,
  SUCCESS,
  WARNING,
  ERROR,

}

export function getCSSClass(type: DialogType) {
  switch (type) {
    case DialogType.SUCCESS:
      return 'success';
    case DialogType.ERROR:
      return 'danger';
    case DialogType.WARNING:
      return 'warning';
    default:
      return 'info';
  }
}
